import styled from 'styled-components'

export const Containner = styled.div`
  margin-bottom: 100px;
`
export const Chart = styled.div`
  display: flex;        
  justify-items: center;
  min-height: 200px;
`

interface ChartColorProps {
  color?: string;
}

export const ChartColor = styled.nav<ChartColorProps>`
  color: ${props => props.color || 'inherit'};
`
export const Causes = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`
export const Line = styled.div`
  width: 100%;
  border-bottom: 6px solid;
  border-color: #E2E2E2 !important;
  margin-left:10px;
`
export const CauseContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 50%;
`
export const CauseTopItem = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;   
  font-size: 0.95em;
  font-weight: 400;        
  color: #4f4f4f;
  padding: 5px 0px;
  padding: 8px 16px 8px 16px;
  border-radius: 50px;
  gap: 10px;
  background: #E2E2E2;
  width:150px;
  margin-right: 50px;
  margin-left: 100px;
`
export const CauseBottomItem = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;   
  font-size: 0.95em;
  font-weight: 400;        
  color: #4f4f4f;
  padding: 8px 16px 8px 16px;
  border-radius: 50px;
  gap: 10px;
  background: #E2E2E2;
  width:150px;
  margin-right: 50px;
  margin-left: 100px;
`
export const ContentCauseRoot = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const CauseTopDiagonalDot = styled.div`
  background-image: radial-gradient(circle at center, #333333 2px, transparent 4px), radial-gradient(circle at center, #333333 2px, transparent 4px);
  background-size: 10px 10px;
  background-position: top center, bottom center;
  background-repeat: no-repeat;
  width:10px;
  height:10px;
  position:absolute;
  margin-top: -5px;
  margin-left: -6px;
` 
export const CauseTopDiagonalLine = styled.div`
  flex: 1;
  height:100%;
  background: linear-gradient(to top right, transparent calc(50% - 3px), rgb(17, 17, 17), transparent calc(50% + 1.5px) );
`
export const CauseBottomDiagonalDot = styled.div`
  background-image: radial-gradient(circle at center, #333333 2px, transparent 4px), radial-gradient(circle at center, #333333 2px, transparent 4px);
  background-size: 10px 10px;
  background-position: top center, bottom center;
  background-repeat: no-repeat;
  width:10px;
  height:10px;
  position:relative;
  margin-left: -6px;
  margin-bottom: -5px;
  display: inline-block;
  align-self: flex-end;
` 
export const CauseBottomDiagonalLine = styled.div`
  display: flex;
  flex: 1;
  height:100%;
  background: linear-gradient(to bottom right, transparent calc(50% - 3px), rgb(17, 17, 17), transparent calc(50% + 1.5px) );
`
export const EffectContainner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right:10px;
`
export const EffectItem = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.95em;
  font-weight: 400; 
  color: #4f4f4f;
  padding: 5px 10px 5px 10px; 
  border: 1px solid white;
  width: 173px;
  height: 225px;
  padding: 8px 23px 8px 23px;
  border-radius: 50px 150px 150px 50px;
  gap: 10px;
  background: #E2E2E2;
  margin-left:10px;
`
export const CausesGroup = styled.div`
  flex: 1;
  display: flex;
  margin-right: 10px;
`
export const CausesRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  flex: 3;
  font-size: 0.85em;
  font-weight: 400;
  color: #4f4f4f;
  text-align: right;
  padding: 15px 0px;
`

export const TitleEffect = styled.span`
  font-size: 14px;
  line-height: 21px;
`

export const dialogPanel = `
w-full 
max-w-[812px] 
h-[280px] 
transform 
overflow-hidden 
rounded-2xl 
bg-white 
p-8 
text-left 
align-middle 
shadow-xl 
transition-all
`

export const dialogTitle = `
text-lg 
font-medium 
leading-6 
text-gray-900
flex
justify-between
`